import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_OFICIO_ARRECADACAO = `${modulo.ARRECADACAO}/oficios`
const URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA = `${URL_OFICIO_ARRECADACAO}/certidaoNegativa`
const URL_OFICIO_MATRICULA = `${URL_OFICIO_ARRECADACAO}/matricula`
const URL_OFICIO_ARRECADACAO_EMISSAO_MINUTAS = `${URL_OFICIO_ARRECADACAO}/emissaoMinutas`

const actions = {
  async tramitarCertidaoNegativa ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/tramitar/${id}`,
      error: true
    })

    return data
  },
  async tramitarMatricula ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${URL_OFICIO_MATRICULA}/tramitar/${id}`,
      error: true
    })

    return data
  },
  async saveCertidaoNegativa ({ commit }, { oficio, cartorios }) {
    const data = await axios({
      method: 'post',
      data: { oficio, cartorios },
      url: URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA,
      error: true
    })

    return data
  },

  async saveMatricula ({ commit }, { dados }) {
    const response = await axios({
      method: 'post',
      url: URL_OFICIO_MATRICULA,
      data: dados,
      error: true
    })
    return response
  },

  async finalizarMatricula ({ commit }, id) {
    const response = await axios({
      method: 'post',
      url: `${URL_OFICIO_MATRICULA}/finalizar`,
      data: {
        id
      },
      error: true
    })
    return response
  },

  async getPDFMatricula ({ commit }, id) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${URL_OFICIO_MATRICULA}/pdf?id=${id}`
    })
  },

  findByProcesso ({ commit }, id) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_MATRICULA}/findByProcesso?id=${id}`
    })
  },

  assinarMatricula ({ commit }, dados) {
    return axios({
      method: 'post',
      url: `${URL_OFICIO_MATRICULA}/assinar`,
      error: true,
      data: dados,
      loader: false
    })
  },

  getPDFCertidaoNegativa ({ commit }, id) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/pdf?id=${id}`
    })
  },

  getPDFCertidaoNegativaByIdProcesso ({ commit }, idProcesso) {
    return axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/pdf/byProcesso?idProcesso=${idProcesso}`
    })
  },

  finalizar ({ commit }, id) {
    return axios({
      method: 'post',
      error: true,
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/finalizar`,
      data: {
        id
      }
    })
  },

  find ({ commit }, filtro) {
    return axios({
      method: 'post',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/find`,
      data: filtro
    })
  },

  findById ({ commit }, id) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO}?id=${id}`,
      error: true
    })
  },

  findByProcessoId ({ commit }, idProcesso) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO}/byProcesso?idProcesso=${idProcesso}`,
      error: true
    })
  },

  envio ({ commit }, id) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/envio?id=${id}`,
      error: true
    })
  },

  validarMatricula ({ commit }, { id, dados }) {
    return axios({
      method: 'post',
      url: `${URL_OFICIO_MATRICULA}/validar?id=${id}`,
      data: dados,
      error: true
    })
  },

  recebimento ({ commit }, { id, dados }) {
    return axios({
      method: 'post',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/recebimento?id=${id}`,
      error: true,
      data: dados
    })
  },

  assinarCertidaoNegativa ({ commit }, dados) {
    return axios({
      method: 'post',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/assinar`,
      error: true,
      data: dados
    })
  },
  getRawDocument ({ commit }, id) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_MATRICULA}/rawDocument?id=${id}`,
      error: true
    })
  },
  editarOficio ({ commit }, dados) {
    return axios({
      method: 'put',
      url: `${URL_OFICIO_MATRICULA}/editarOficio`,
      error: true,
      data: dados
    })
  },
  async tramitarEmissaoMinutas ({ commit }, id) {
    const data = await axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO_EMISSAO_MINUTAS}/tramitar/${id}`,
      error: true
    })

    return data
  },
  async deleteById ({ commit }, id) {
    return axios({
      method: 'delete',
      url: `${URL_OFICIO_ARRECADACAO}/deleteById?oficioId=${id}`,
      error: true
    })
  },

  getDadosAnexos ({ commit }) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO}/dadosAnexos/getAll`,
      error: true
    })
  },

  getAllCertidoesPdfsByProcesso ({ commit }, idProcesso) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/getPdfs/${idProcesso}`,
      error: true
    })
  },

  getAllCertidoesPdfsByOficiosIn ({ commit }, idsOficios) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/getPdfsByOficios?idsOficios=${idsOficios}`,
      error: true
    })
  },
  findByTipoAndIdProcesso ({ commit }, params) {
    return axios({
      method: 'get',
      url: `${URL_OFICIO_ARRECADACAO}/findByTipoAndIdProcesso`,
      params: params
    })
  },
  deleteAllCertidoesNaoAssinadas ({ commit }, idProcesso) {
    return axios({
      method: 'delete',
      url: `${URL_OFICIO_ARRECADACAO_CERTIDAO_NEGATIVA}/deleteByProcesso?idProcesso=${idProcesso}`,
      loader: false,
      error: false
    })
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/oficioArrecadacao.js